import { DateTime } from 'luxon';
import { getAgeYearsFromBirthDate, getDateOfBirthFromIdNumber } from 'src/helpers/dates';

const MIN_AGE_LIMIT_YEARS = 18;

const getAge = (birthDate: Date): number => {
  const todayDateTime = DateTime.fromJSDate(new Date());
  const birthDateTime = DateTime.fromJSDate(birthDate);
  const diffTime = todayDateTime.diff(birthDateTime, ['years']);

  return Math.floor(diffTime.years);
};

export const isUserUnderAgeIdNumber = (idNumber: string) => {
  const today = new Date();
  const dateOfBirth = getDateOfBirthFromIdNumber(idNumber);
  const ageYears = getAgeYearsFromBirthDate(dateOfBirth, today);
  return ageYears < MIN_AGE_LIMIT_YEARS;
};

/**
 * @param date Date of Birth
 * @returns true if user is over the minimum age limit, in this case 18 years old.
 */
export const isUnderAge = (date: Date): boolean => {
  const ageInYears = getAge(date);

  return ageInYears < MIN_AGE_LIMIT_YEARS;
};

/**
 * @param date Passport expiry date
 * @returns true if passport is valid for the next 6 months (including today)
 * @description
 * Passport expiry date is valid if it is after 6 months from today.
 * This is to prevent users from using expired passports.
 */
export const isValidPassportExpiryDate = (date: Date): boolean => {
  const today = new Date();

  const sixMonthsFromToday = today;
  sixMonthsFromToday.setMonth(today.getMonth() + 6);

  return date >= sixMonthsFromToday;
};
